import React from "react";

import { BrowserRouter as Router } from "react-router-dom";

import { ThemeProvider } from "@material-ui/styles";

import theme from "./constants/theme";
import Routes from "./Routes";

function App() {
  return (
    <div>
      <ThemeProvider theme={theme}>
        <Router basename="rode">
          <Routes />
        </Router>
      </ThemeProvider>
    </div>
  );
}

export default App;
